export default __webpack_public_path__ + "static/media/MasaiXCourseImage1.58b45bab.svg";